import React, { useState } from "react";

const VOCE_NUOVO = "__nuovo__";

// Popup "🔤 Sviluppi" (vedi OrdiniMapping.jsx, colonna Taglia_NomeCalzata):
// per ogni valore "nome calzata" trovato nel file che non ha ancora una
// corrispondenza salvata, si sceglie a quale sviluppo corrisponde.
//
// Un operatore normale può scegliere SOLO tra gli sviluppi già esistenti
// (creati da wtrendy dal pannello Impostazioni): un refuso o un valore
// sbagliato nel file non deve poter finire nel vocabolario dell'ERP.
//
// wtrendy invece deve avere sempre tutte le funzionalità disponibili (anche
// quelle "da admin"): con puoCreareSviluppi=true può anche scrivere al volo
// uno sviluppo nuovo direttamente da qui ("+ nuovo sviluppo..."), e il
// vocabolario qui sotto diventa gestibile (aggiungi/togli) invece che di
// sola consultazione — non deve essere costretto ad aprire Impostazioni solo
// per provare la funzionalità che sta testando.
export default function LegendaSviluppiModal({
  azienda, sviluppi, valoriDaRisolvere, puoCreareSviluppi, onSalvaMappature, onCreaSviluppo, onEliminaSviluppo, onChiudi,
}) {
  const [scelte, setScelte] = useState({}); // { valoreGrezzo: sviluppo scelto | VOCE_NUOVO }
  const [nuoviTesti, setNuoviTesti] = useState({}); // { valoreGrezzo: testo nuovo sviluppo, se scelto VOCE_NUOVO }
  const [nuovoSviluppoGlobale, setNuovoSviluppoGlobale] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [errore, setErrore] = useState("");

  function impostaScelta(valoreGrezzo, valore) {
    setScelte((prev) => ({ ...prev, [valoreGrezzo]: valore }));
  }

  function valoreFinalePer(valoreGrezzo) {
    const scelta = scelte[valoreGrezzo];
    if (!scelta) return "";
    if (scelta === VOCE_NUOVO) return (nuoviTesti[valoreGrezzo] || "").trim();
    return scelta;
  }

  const pronteDaSalvare = valoriDaRisolvere.filter((v) => valoreFinalePer(v) !== "");

  async function applicaRisolti() {
    if (pronteDaSalvare.length === 0) return;
    setErrore("");
    setSalvando(true);
    try {
      // Prima creo (una volta sola, senza duplicati) gli eventuali sviluppi
      // nuovi scelti — solo possibile se puoCreareSviluppi (wtrendy) — poi
      // salvo tutte le corrispondenze verso quelli, nuovi o già esistenti.
      if (puoCreareSviluppi) {
        const nuovi = [...new Set(pronteDaSalvare.filter((v) => scelte[v] === VOCE_NUOVO).map((v) => valoreFinalePer(v)))];
        for (const nome of nuovi) await onCreaSviluppo(nome);
      }
      const mappature = {};
      for (const v of pronteDaSalvare) mappature[v] = valoreFinalePer(v);
      await onSalvaMappature(mappature);
      // Tolgo dagli stati locali solo quelle appena risolte: il genitore
      // ricalcola valoriDaRisolvere dopo il salvataggio, quindi spariscono
      // da sole dalla lista qui sopra.
      setScelte((prev) => {
        const copia = { ...prev };
        for (const v of pronteDaSalvare) delete copia[v];
        return copia;
      });
      setNuoviTesti((prev) => {
        const copia = { ...prev };
        for (const v of pronteDaSalvare) delete copia[v];
        return copia;
      });
    } catch (e) {
      setErrore(e.message);
    } finally {
      setSalvando(false);
    }
  }

  async function aggiungiSviluppoGlobale() {
    const testo = nuovoSviluppoGlobale.trim();
    if (!testo) return;
    setErrore("");
    setSalvando(true);
    try {
      await onCreaSviluppo(testo);
      setNuovoSviluppoGlobale("");
    } catch (e) {
      setErrore(e.message);
    } finally {
      setSalvando(false);
    }
  }

  async function togliSviluppo(nome) {
    setErrore("");
    setSalvando(true);
    try {
      await onEliminaSviluppo(nome);
    } catch (e) {
      setErrore(e.message);
    } finally {
      setSalvando(false);
    }
  }

  return (
    <div
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15, 23, 42, 0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: "Inter, sans-serif" }}
      onClick={onChiudi}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: "var(--cf-bg-card)", borderRadius: "16px", width: "640px", maxWidth: "92vw", maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.45)" }}
      >
        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)", padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "20px", lineHeight: 1 }}>🔤</span>
            <div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontWeight: 700, fontSize: "15px", letterSpacing: "1px", textTransform: "uppercase", color: "#f1f5f9" }}>
                Abbina sviluppi
              </div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontSize: "11px", color: "var(--cf-text-faint)", letterSpacing: "0.3px", marginTop: "3px" }}>
                {azienda}
              </div>
            </div>
          </div>
          <button className="cf-btn" onClick={onChiudi} style={{ border: "none", background: "rgba(255,255,255,0.08)", borderRadius: "6px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", color: "#cbd5e1", lineHeight: 1 }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "24px", overflowY: "auto" }}>
          {errore && <p className="errore" style={{ marginTop: 0 }}>{errore}</p>}

          {sviluppi.length === 0 && !puoCreareSviluppi && (
            <p className="testo-secondario" style={{ marginTop: 0 }}>
              Nessuno sviluppo ancora caricato per la tua azienda: chiedi a wtrendy di popolare l'elenco dal pannello
              Impostazioni prima di poter abbinare i valori qui sotto.
            </p>
          )}

          <div style={{ fontSize: "11px", fontWeight: 700, color: "var(--cf-text-muted)", textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: "8px", fontFamily: "'Roboto Mono', Consolas, monospace" }}>
            Da risolvere in questo file ({valoriDaRisolvere.length})
          </div>
          {valoriDaRisolvere.length === 0 ? (
            <p className="testo-secondario" style={{ marginTop: 0, marginBottom: "20px" }}>
              Nessun valore "nome calzata" senza corrispondenza — tutti riconosciuti.
            </p>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "20px" }}>
              {valoriDaRisolvere.map((v) => (
                <div key={v} style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px 10px", borderRadius: "8px", backgroundColor: "var(--cf-bg-subtle)", border: "1px solid var(--cf-border)" }}>
                  <span style={{ flex: "1 1 auto", fontSize: "13px", wordBreak: "break-word" }} title={v}>{v}</span>
                  <span style={{ color: "var(--cf-text-faint)" }}>→</span>
                  <select
                    value={scelte[v] || ""}
                    onChange={(e) => impostaScelta(v, e.target.value)}
                    style={{ minWidth: "12rem" }}
                  >
                    <option value="">-- scegli sviluppo --</option>
                    {sviluppi.map((s) => <option key={s} value={s}>{s}</option>)}
                    {puoCreareSviluppi && <option value={VOCE_NUOVO}>+ nuovo sviluppo...</option>}
                  </select>
                  {puoCreareSviluppi && scelte[v] === VOCE_NUOVO && (
                    <input
                      type="text"
                      placeholder="nome nuovo sviluppo"
                      value={nuoviTesti[v] || ""}
                      onChange={(e) => setNuoviTesti((prev) => ({ ...prev, [v]: e.target.value }))}
                      style={{ width: "10rem" }}
                    />
                  )}
                </div>
              ))}
              <button
                className="btn-primario"
                onClick={applicaRisolti}
                disabled={salvando || pronteDaSalvare.length === 0}
                style={{ alignSelf: "flex-start" }}
              >
                {salvando ? "Salvataggio..." : `Applica e salva (${pronteDaSalvare.length}/${valoriDaRisolvere.length})`}
              </button>
            </div>
          )}

          {(sviluppi.length > 0 || puoCreareSviluppi) && (
            <>
              <div style={{ fontSize: "11px", fontWeight: 700, color: "var(--cf-text-muted)", textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: "8px", fontFamily: "'Roboto Mono', Consolas, monospace" }}>
                Sviluppi disponibili per questa azienda ({sviluppi.length})
              </div>
              {!puoCreareSviluppi && (
                <p className="testo-secondario" style={{ marginTop: 0, marginBottom: "10px" }}>
                  Vocabolario curato da wtrendy — qui solo in consultazione.
                </p>
              )}
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: puoCreareSviluppi ? "12px" : 0 }}>
                {sviluppi.length === 0 && <span className="testo-secondario">Nessuno ancora.</span>}
                {sviluppi.map((s) => (
                  <span key={s} style={{ display: "inline-flex", alignItems: "center", gap: "4px", padding: "4px 8px", borderRadius: "999px", backgroundColor: "var(--cf-bg-subtle)", border: "1px solid var(--cf-border-strong)", fontSize: "12px" }}>
                    {s}
                    {puoCreareSviluppi && (
                      <button
                        onClick={() => togliSviluppo(s)}
                        disabled={salvando}
                        title={`Togli "${s}" dal vocabolario`}
                        style={{ border: "none", background: "none", cursor: salvando ? "wait" : "pointer", padding: 0, lineHeight: 1, color: "var(--cf-text-faint)" }}
                      >
                        ✕
                      </button>
                    )}
                  </span>
                ))}
              </div>
              {puoCreareSviluppi && (
                <div className="riga-controlli">
                  <input
                    type="text"
                    placeholder="nuovo sviluppo..."
                    value={nuovoSviluppoGlobale}
                    onChange={(e) => setNuovoSviluppoGlobale(e.target.value)}
                    onKeyDown={(e) => { if (e.key === "Enter") aggiungiSviluppoGlobale(); }}
                    disabled={salvando}
                  />
                  <button onClick={aggiungiSviluppoGlobale} disabled={salvando || !nuovoSviluppoGlobale.trim()}>
                    + aggiungi
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        <div style={{ padding: "16px 24px", borderTop: "1px solid var(--cf-border)", display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
          <button onClick={onChiudi}>Chiudi</button>
        </div>
      </div>
    </div>
  );
}
